import { EventEmitter, Injectable, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthServiceInterface } from "./auth.service.interface";


@Injectable({ providedIn: 'root' })
export class AuthService implements AuthServiceInterface {
  @Output() newExpirationSet: EventEmitter<boolean> = new EventEmitter();

  currentLang: string = 'en';

  constructor(public translateService: TranslateService,
    public router: Router) {
    this.currentLang = translateService.currentLang
    translateService.onLangChange.subscribe(lang => this.currentLang = lang.lang);
  }

  private isUserSignedIn: boolean = false;
  private cookieExpiry: number

  setSessionExpiry(expiry: number) {
    this.cookieExpiry = expiry
    this.isUserSignedIn = true
    this.newExpirationSet.emit(true)
  }

  sessionToExpireWithinTime(): number {
    var now = new Date()
    var utcDate = (Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds(), now.getUTCMilliseconds())) / 1000

    return Math.floor((this.cookieExpiry - utcDate) / 60)
  }

  isSessionExpiryValid() {
    var now = new Date()
    var utcDate = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds(), now.getUTCMilliseconds())
    return this.cookieExpiry != null && this.cookieExpiry != undefined && this.cookieExpiry > (utcDate / 1000);
  }

  isSessionExpiryNull() {
    return this.cookieExpiry == null || this.cookieExpiry == undefined
  }

  setIsAuthenticated(isAuthenticated: boolean) {
    this.isUserSignedIn = isAuthenticated;
  }

  isUserLoggedIn(): boolean {
    return this.isUserSignedIn;
  }

  goToLogout() {
    sessionStorage.setItem('reload', 'true')
    this.router.navigate([(this.currentLang == 'fr' ? 'fr' : '') + '/training-provider/register-as-training-provider'])
  }
}
